(ns frontend.view.modals.choice-confirmation.events)

(defn reset-state! [state]
  (reset! state {}))

(defn toggle-confirmed! [state val]
  (swap! state assoc-in [:confirmed?] val))
